<div class="row align-items-center">
    <div class="col">
        <div class="mb-3">
            <label class="form-label">Si contesto en la pregunta:</label>
            <ng-select class="ps-1 flex-grow-1" [items]="preguntas" bindLabel="texto" [(ngModel)]="preguntaSeleccionada"
                (change)="preguntaCambio()">
                <ng-template ng-option-tmp let-item="item">
                    {{item.idRelativo}}. {{item.texto}}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    {{item.idRelativo}}
                </ng-template>
            </ng-select>
        </div>
    </div>
    <div class="col" *ngIf="preguntaSeleccionada?.tipo === PreguntasTipoEnum.MATRIX_SINGLE ||
        preguntaSeleccionada?.tipo === PreguntasTipoEnum.MATRIX_MULTIPLE">
        <div class="mb-3">
            <label class="form-label">En la subpregunta:</label>
            <ng-select class="ps-1 flex-grow-1" [items]="preguntaSeleccionada!.preguntas" bindLabel="texto"
                [(ngModel)]="subpreguntaSeleccionada" (change)="subpreguntaCambio()">
                <ng-template ng-option-tmp let-item="item">
                    {{item.idRelativo}}. {{item.texto}}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    {{item.idRelativo}}
                </ng-template>
            </ng-select>
        </div>
    </div>
    <div class="col">
        <div class="mb-3">
            <label class="form-label">La respuesta:</label>
            <ng-select class="ps-1 flex-grow-1" [items]="respuestas" bindLabel="texto" [(ngModel)]="itemSeleccionado"
                [disabled]="!preguntaSeleccionada" (change)="itemCambio()">
                <ng-template ng-option-tmp let-item="item">
                    {{item.idRelativo}} - {{item.texto}}
                </ng-template>
                <ng-template ng-label-tmp let-item="item">
                    {{item.idRelativo}}
                </ng-template>
            </ng-select>
        </div>
    </div>
    <div class="col flex-grow-0 text-end my-auto" [class.seleccionable]="borrarOperandoCmd.puedeEjecutarse"
        [command]="borrarOperandoCmd">
        <span><i class="fa-regular fa-trash-can fa-xl"></i></span>
    </div>
</div>
